import { AppConfig } from '../config/AppConfig';
import type { ApiResult } from '../auth/AuthTokenTypes';

export interface AuthCheckApiResponse {
  subject: string;
  email?: string;
  requestId: string;
  issuer?: string;
  expiresAt?: number;
}

export interface ApiClientOptions {
  /** Abort signal for cancellation */
  signal?: AbortSignal;
}

export function buildAuthHeader(token: string): Record<string, string> {
  if (!token) return {};
  return { Authorization: `Bearer ${token}` };
}

export async function getAuthCheck(
  idToken: string,
  options?: ApiClientOptions,
): Promise<ApiResult<AuthCheckApiResponse>> {
  const config = AppConfig.get();
  const url = `${config.api.baseUrl.replace(/\/$/, '')}/auth-check`;
  try {
    const resp = await fetch(url, {
      method: 'GET',
      headers: buildAuthHeader(idToken),
      signal: options?.signal,
    });
    if (resp.ok) {
      const data = (await resp.json()) as AuthCheckApiResponse;
      return { ok: true, status: resp.status, data };
    }
    return { ok: false, status: resp.status, error: 'API request failed' };
  } catch (e) {
    if (e instanceof DOMException && e.name === 'AbortError') {
      return { ok: false, status: 0, error: 'Request aborted' };
    }
    return { ok: false, status: 0, error: 'Network error' };
  }
}
